export const PREDEFINED_BLUEPRINT_TYPES_TITLES = {
	'meeting-notes': 'content.kind.meeting-notes',
	decisions: 'content.kind.decisions',
	'kb-how-to-article': 'content.kind.kb-how-to-article',
	'file-list': 'content.kind.file-list',
	retrospective: 'content.kind.retrospective',
	requirements: 'content.kind.product-requirements',
	'shared-links': 'content.kind.shared-links',
	'kb-troubleshooting-article': 'content.kind.kb-troubleshooting-article',
	'task-report': 'content.kind.task-report',
	jirareport: 'content.kind.jirareport',
};
